/*eslint-disable*/
import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import { useNavigate, useLocation } from "react-router-dom";
import GridItem from "components/Grid/GridItem.js";
import { offices, STYLES } from "config";
import GridContainer from "components/Grid/GridContainer.js";
import moment from "moment";
import {
    Row,
    Col,
    Label,
    CardBody,
    Card,
    CardHeader,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    FormText,
    Button,
} from "reactstrap";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import CreateAreaDashboardModal from "components/CreateAreaDashboardModal";
import CustomDropDownPicker from "components/CustomDropDownPicker";

import AddBoxRounded from "@material-ui/icons/AddBoxRounded";
import { FirebaseContext } from "common";

const areaManagement = () => {
    const { api } = useContext(FirebaseContext);
    const {
        createBranch,
        clearBranchErrors,
        fetchBranchesEnquiries,
        fetchAllBranchListings,
        updateBranch,
        deleteBranch,
        updateArea,
        deleteArea,
        fetchCities,
        fetchPPCities,
        fetchPPSuburbs,
        fetchSuburbs,
        fetchWebsiteAreas,
    } = api;


    //console.log(api);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const branchManagementReducer = useSelector((state) => state.branchData);
    const usertypes = useSelector((state) => state.usertypes.userstypes);
    //const brokers = useSelector((state) => state.brokers.users);
    const areaData = useSelector((state) => state.areaData);
    const usersdata = useSelector((state) => state.usersdata);
    const ppcities = useSelector((state) => state.citiesdata.ppcities);
    const ppsuburbs = useSelector((state) => state.citiesdata.ppsuburbs);
    const cities = useSelector((state) => state.citiesdata.city);
    const suburbs = useSelector((state) => state.citiesdata.suburb);
    const websiteAreas = useSelector((state) => state.citiesdata.websiteArea)
    const tokenManagementReducer = useSelector((state) => state.tokendata.token.token);

    const adminsdata = useSelector((state) => state.usersdata.admins);

    // State for modal visibility and form data
    const [brokerList, setBrokerList] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const auth = useSelector((state) => state.auth);
    const [selectedBrokers, setSelectedBrokers] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState([]);
    const [ppCitiesOptions, setppCitiesOptions] = useState([])
    const [ppSuburbsOptions, setppSuburbsOptions] = useState([])
    const [selectedArea, setSelectedArea] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedBranchToDelete, setSelectedBranchToDelete] = useState(null);
    const [selectedAreaToDelete, setSelectedAreaToDelete] = useState(null);
    const [branchList, setBranchList] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [suburbOption, setSuburbOption] = useState([]);
    const [areaTableData, setAreaTableData] = useState([]);
    const [websiteAreaOptions, setWebsiteAreaOptions] = useState([])

    const [areaDetailsState, setAreaDetailsState] = useState({
        provinceName: "",
        cityName: "",
        suburbName: "",
    });

    const [successMessage, setSuccessMessage] = useState("");

    let areas = areaData.areas;
    const branchData = branchManagementReducer.branches;
    const [error, setError] = useState(null);
    const [editAreaData, setEditAreaData] = useState({
        areaId: "",
        areaName: "",
        p24: { provinceName: "", cityName: "", suburbName: "", geoPoint: "" },
        pp: {
            provinceId: "",
            cityId: "",
            suburbId: ""
        },
        selectedBranchName: "",
        shareBrokers: [],
    });
    const [officeData, setBranchData] = useState({
        BranchName: "",
        Province: "",
        manager: "",
        address: "",
        contactInfo: "",
        admin: "",

        // share: auth?.info?.profile?.brokerHomeOffice,
    });

    const provinceOptions = [
        { value: '7', label: 'Eastern Cape' },
        { value: '3', label: 'Free State' },
        { value: '1', label: 'Gauteng' },
        { value: '2', label: 'KwaZulu Natal' },
        { value: '14', label: 'Limpopo' },
        { value: '5', label: 'Mpumalanga' },
        { value: '6', label: 'North West' },
        { value: '8', label: 'Northern Cape' },
        { value: '9', label: 'Western Cape' },
    ];

    const ppProvinceOptions = [
        { value: 1, label: 'Gauteng' },
        { value: 2, label: 'KwaZulu Natal' },
        { value: 3, label: 'Free State' },
        { value: 5, label: 'Mpumalanga' },
        { value: 6, label: 'North West' },
        { value: 7, label: 'Eastern Cape' },
        { value: 8, label: 'Northern Cape' },
        { value: 9, label: 'Western Cape' },
        { value: 1, label: 'Limpopo' },
    ];

    const [isCardView, setIsCardView] = useState(true);
    const toggleModal = () => setIsOpen(!isOpen);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setBranchData({ ...officeData, [name]: value });
    };

    const updateDropDown = (id, value) => {

        console.log('id', id)
        console.log('value', value)
        const updatedP24 = { ...editAreaData?.p24, [id]: value };
        setEditAreaData(prevState => ({
            ...prevState,
            p24: updatedP24
        }));
        console.log("updatedP24", updatedP24, `state`, editAreaData);
    };

    const handleBrokerChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedBrokers(selectedValue); // Update selectedBroker
        setBranchData({ ...officeData, manager: selectedValue }); // Sync with officeData.manager
    };

    const handleDeleteClick = (rowData) => {
        setSelectedAreaToDelete(rowData);
        setIsDeleteModalOpen(true);
    };



    useEffect(() => {
        console.log('ppcities', ppcities)
        if (ppcities?.length > 0) {
            const formattedCities = ppcities.map((city) => ({
                value: city.Id,
                label: city.Name

            }));
            setppCitiesOptions(formattedCities);
        }
    }, [ppcities])


    useEffect(() => {
        console.log('ppsuburbs', ppsuburbs)
        if (ppsuburbs?.length > 0) {
            const formattedCities = ppsuburbs.map((suburb) => ({
                value: suburb.Id,
                label: suburb.Name
            }));
            setppSuburbsOptions(formattedCities);
        }
    }, [ppsuburbs])




    const updateAreaDetails = (location, data) => {

        setAreaDetailsState({
            ...areaDetailsState,
            [location]: data.label,
        });
        console.log(`areaDetailsState: ${JSON.stringify(areaDetailsState)}`)
    };



    const addGeoPoint = (suburbId) => {
        let suburb = suburbs.suburbs.find(sub => sub.id === suburbId)
        console.log('geoPoint', suburb.geoPoint)

        const updatedP24 = { ...editAreaData?.p24, ["geoPoint"]: suburb.geoPoint, suburbId: suburbId };
        setEditAreaData(prevState => ({
            ...prevState,
            p24: updatedP24
        }));
        console.log("updatedP24", updatedP24, `state`, editAreaData);
    };

    const confirmDelete = async () => {
        if (selectedAreaToDelete) {
            try {
                console.log(`In confirm delete: ${JSON.stringify(selectedAreaToDelete)}`)
                await dispatch(
                    deleteArea(selectedAreaToDelete)
                );
                alert("Area deleted successfully!");
                setIsDeleteModalOpen(false);
                setSelectedAreaToDelete(null); // Clear selection
            } catch (error) {
                console.error("Error deleting area:", error);
                alert("Failed to delete area: " + error.message); // Notify user on failure
            }
        }
    };
    //Admin handler
    const handleAdminChange = (e) => {
        const selectedOption = e.target.value;
        setSelectedAdmin(selectedOption);
        setBranchData({ ...officeData, admin: selectedOption }); // Sync with officeData.manager
    };

    // Handle submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await dispatch(createBranch(officeData));

        if (result.success) {
            alert(result.message);
            toggleModal();
            setBranchData({
                BranchName: "",
                Province: "",
                manager: "",
                address: "",
                contactInfo: "",
                admin: " ",
            });
        }
        if (result.success) {
            alert(result.message);
            toggleModal();
            setBranchData({
                BranchName: "",
                Province: "",
                manager: "",
                address: "",
                contactInfo: "",
                admin: " ",
            });
        }
    };

    //Edit button
    const handleEditClick = (rowData) => {
        setSelectedArea(rowData);
        setEditAreaData({
            areaId: rowData?.areaId,
            areaName: rowData?.areaName || rowData?.Location,
            p24: rowData?.p24,
            pp: rowData?.pp,
            selectedBranchName: rowData?.selectedBranchName,
            shareBrokers: rowData?.shareBrokers,
        });
        setAreaDetailsState({
            provinceName: "",
            cityName: "",
            suburbName: "",
        })
        setIsEditModalOpen(true);
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        console.log(`edit area data:`, JSON.stringify(editAreaData))
        dispatch(
            updateArea(editAreaData)
        );
        alert("Area updated successfully!");
        setIsEditModalOpen(false);
    };


    function concatLocationString(province, city, suburb) {

        if (province === "" && city === "" && suburb === "") {
            //alert("Please enter a province, city and suburb")
            return "";
        }

        let locationString = `South Africa, ${province}, ${city}, ${suburb}`;

        return (
            locationString
        );
    }

    function generateLocationAbbr(city, suburb) {

        if (city === "" && suburb === "") {
            //alert("Please enter a city or suburb to generate an abbreviation.");
            return "";
        }

        let locationAbbr = `${capitalizeFirstLetter(city).slice(
            0,
            3
        )}${capitalizeFirstLetter(suburb).slice(0, 2)}`;

        return (
            locationAbbr
        );
    }

    const capitalizeFirstLetter = (text) => {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    };

    useEffect(() => {
        dispatch(fetchWebsiteAreas());
    }, []);

    useEffect(() => {
        if (websiteAreas?.areas?.length > 0) {
            const formattedWebsiteAreas = websiteAreas.areas.map((area) => ({
                value: area.id,
                label: area.name
            }));
            setWebsiteAreaOptions(formattedWebsiteAreas);
        }
    }, [websiteAreas]);

    useEffect(() => {
        if (areaDetailsState.provinceName !== "" && areaDetailsState.cityName !== "" && areaDetailsState.suburbName !== "") {
            setEditAreaData(prevState => ({
                ...prevState,
                areaName: concatLocationString(areaDetailsState.provinceName, areaDetailsState.cityName, areaDetailsState.suburbName),
            }));
            console.log(`Area Name: ${editAreaData.areaName}`);
        }

    }, [areaDetailsState.provinceName, areaDetailsState.cityName, areaDetailsState.suburbName]);

    useEffect(() => {
        if (editAreaData?.p24?.provinceId) {
            dispatch(fetchCities(editAreaData.p24.provinceId))
        }
        if (editAreaData?.p24?.cityId) {
            dispatch(fetchSuburbs(editAreaData.p24.cityId))
        }
    }, [editAreaData]);

    useEffect(() => {
        if (editAreaData?.pp?.provinceId) {
            dispatch(fetchPPCities(editAreaData.pp.provinceId, tokenManagementReducer))
        }
        if (editAreaData?.pp?.cityId) {
            dispatch(fetchPPSuburbs(editAreaData.pp.cityId, tokenManagementReducer))
        }
    }, [editAreaData]);

    useEffect(() => {
        if (cities?.cities?.length > 0) {
            const formattedCities = cities.cities.map((city) => ({
                value: city.id,
                label: city.name
            }));


            console.log('formattedCities', formattedCities)

            setCityOptions(formattedCities);
        }

    }, [cities]);

    useEffect(() => {


        console.log('suburbs', suburbs)

        if (suburbs?.suburbs?.length > 0) {
            const formattedSuburbs = suburbs.suburbs.map((sub) => ({
                value: sub.id,
                label: sub.name
            }));
            setSuburbOption(formattedSuburbs);
        }
    }, [suburbs]);

    useEffect(() => {
        let arr2 = [];

        if (branchData) {
            //console.log("Branch Data:", branchData); // Log branch data to verify data
            for (let index = 0; index < branchData.length; index++) {
                const element = branchData[index];

                arr2.push({
                    value: element.branchId, // The branch ID (or name if preferred)
                    label: `${element.BranchName}`, // Branch name
                });

            }
            setBranchList(arr2.sort((a, b) => a.label.localeCompare(b.label)));
            console.log("Branch List:", arr2); // Log branch list to verify population
        }
    }, [branchData]);

    const renderDeleteModal = () => (
        <Modal
            isOpen={isDeleteModalOpen}
            toggle={() => setIsDeleteModalOpen(false)}
            centered
        >
            <ModalHeader>
                Confirm Delete
            </ModalHeader>
            <ModalBody>
                Are you sure you want to delete the area "
                {selectedAreaToDelete?.Location ? selectedAreaToDelete?.Location : selectedAreaToDelete.areaName}"?
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={confirmDelete}>
                    Yes, Delete
                </Button>
                <Button onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
    const renderEditModal = () => (
        <Modal isOpen={isEditModalOpen} toggle={() => setIsEditModalOpen(false)} centered={true} size="xl" style={{ marginLeft: "350px" }}>
            <ModalHeader>Edit Area</ModalHeader>
            <ModalBody>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                    <GridContainer spacing={1}>
                        <GridItem lg={4}>
                            <Card
                                style={{
                                    backgroundColor: STYLES.PRIMARY_APP_CLR,
                                    width: "95%",
                                    height: "100%",
                                    justifyContent: "center"
                                }}
                            >
                                <CardHeader>
                                    <CardTitle tag="h4" style={{ color: "white" }}>
                                        Area Details
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>

                                    <GridContainer spacing={1}>
                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Area Name:
                                            </FormText>
                                            <FormText style={{ color: 'red', fontSize: '12px' }} tag="span">
                                                This will be auto-populated
                                            </FormText>
                                            <Input
                                                disabled
                                                fullWidth
                                                type="text"
                                                style={{
                                                    borderWidth: 2,
                                                    borderColor: "#f00000",
                                                    height: 35,
                                                    backgroundColor: "white",
                                                    fontSize: 16,
                                                    paddingHorizontal: 10,
                                                    paddingVertical: 8,
                                                    borderRadius: 8,
                                                    color: "grey",
                                                    paddingRight: 30,
                                                }}
                                                name="AreaName"
                                                value={editAreaData?.areaName}
                                                onChange={(e) =>
                                                    setEditAreaData({ ...editAreaData, areaName: e.target.value })
                                                }
                                                required
                                            />
                                        </GridItem>

                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Notes:
                                            </FormText>
                                            <Input
                                                fullWidth
                                                type="textarea"
                                                style={{
                                                    borderWidth: 2,
                                                    borderColor: "#f00000",
                                                    height: 35,
                                                    backgroundColor: "white",
                                                    fontSize: 16,
                                                    paddingHorizontal: 10,
                                                    paddingVertical: 8,
                                                    borderRadius: 8,
                                                    color: "grey",
                                                    paddingRight: 30,
                                                }}
                                                placeholder="Notes"
                                                value={editAreaData?.notes || ""}
                                                onChange={(e) =>
                                                    setEditAreaData({ ...editAreaData, notes: e.target.value })
                                                }
                                            />
                                        </GridItem>

                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Branch:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            {branchList && branchList.length > 0 ? (
                                                <CustomDropDownPicker
                                                    options={branchList}
                                                    isMulti={false}
                                                    onChange={(value) => {
                                                        let selectedBranch = branchList.find(branch => branch.value === value);
                                                        setEditAreaData({
                                                            ...editAreaData,
                                                            selectedBranchName: selectedBranch.label
                                                        })
                                                    }}
                                                    value={editAreaData?.selectedBranchName}
                                                />
                                            ) : (
                                                <FormText color="grey">No branches available</FormText>
                                            )}
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Brokers:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            {brokerList && brokerList.length > 0 ? (
                                                <CustomDropDownPicker
                                                    options={brokerList}
                                                    isMulti={true}
                                                    onChange={(selectedBrokers) => {
                                                        setEditAreaData({
                                                            ...editAreaData,
                                                            shareBrokers: selectedBrokers
                                                        })
                                                    }}
                                                    value={editAreaData?.shareBrokers || []}
                                                />
                                            ) : (
                                                <FormText color="grey">No brokers available</FormText>
                                            )}
                                        </GridItem>
                                    </GridContainer>

                                </CardBody>
                            </Card>
                        </GridItem>

                        <GridItem lg={4}>
                            <Card
                                style={{
                                    backgroundColor: STYLES.PRIMARY_APP_CLR,
                                    width: "95%",
                                    height: "100%",
                                    justifyContent: "center"
                                }}
                            >
                                <CardHeader>
                                    <CardTitle tag="h4" style={{ color: "white" }}>
                                        Property24
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer spacing={1}>
                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Province:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            <CustomDropDownPicker
                                                options={provinceOptions}
                                                isMulti={false}
                                                onChange={(selectedProv) => {
                                                    updateDropDown("provinceId", selectedProv)
                                                    let provinceObj = provinceOptions.find(prov => prov.value === selectedProv)
                                                    updateAreaDetails("provinceName", provinceObj)
                                                }}
                                                value={editAreaData.p24.provinceId}
                                            />
                                        </GridItem>

                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                City:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            <CustomDropDownPicker
                                                options={cityOptions}
                                                isMulti={false}
                                                onChange={(selectedCit) => {
                                                    updateDropDown("cityId", selectedCit)
                                                    let cityObj = cityOptions.find(city => city.value === selectedCit)
                                                    updateAreaDetails("cityName", cityObj)
                                                }}
                                                value={editAreaData.p24.cityId}
                                            />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Suburb:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            <CustomDropDownPicker
                                                options={suburbOption}
                                                isMulti={false}
                                                onChange={(selectedSub) => {
                                                    updateDropDown("suburbId", selectedSub)
                                                    let suburbObj = suburbOption.find(suburb => suburb.value === selectedSub)
                                                    addGeoPoint(selectedSub);
                                                    updateAreaDetails("suburbName", suburbObj)
                                                }}
                                                value={editAreaData.p24.suburbId}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>



                        <GridItem lg={4}>
                            <Card
                                style={{
                                    backgroundColor: STYLES.PRIMARY_APP_CLR,
                                    width: "95%",
                                    height: "100%",
                                    justifyContent: "center"
                                }}
                            >
                                <CardHeader>
                                    <CardTitle tag="h4" style={{ color: "white" }}>
                                        Private Property
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer spacing={1}>
                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Province:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            <CustomDropDownPicker
                                                options={ppProvinceOptions}
                                                isMulti={false}
                                                onChange={(selectedProv) => {
                                                    setEditAreaData({
                                                        ...editAreaData,
                                                        pp: {
                                                            ...editAreaData.pp,
                                                            provinceId: selectedProv
                                                        }
                                                    })
                                                }}
                                                value={editAreaData?.pp?.provinceId}
                                            />
                                        </GridItem>

                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                City:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            <CustomDropDownPicker
                                                options={ppCitiesOptions}
                                                isMulti={false}
                                                onChange={(selectedCit) => {
                                                    setEditAreaData({
                                                        ...editAreaData,
                                                        pp: {
                                                            ...editAreaData.pp,
                                                            cityId: selectedCit
                                                        }
                                                    })
                                                }}
                                                value={editAreaData?.pp?.cityId}
                                            />
                                        </GridItem>
                                        <GridItem xs={12}>
                                            <FormText color="white" tag="span">
                                                Suburb:
                                            </FormText>
                                            <FormText color="red" tag="span">
                                                Required
                                            </FormText>

                                            <CustomDropDownPicker
                                                options={ppSuburbsOptions}
                                                isMulti={false}
                                                onChange={(selectedSub) => {
                                                    setEditAreaData({
                                                        ...editAreaData,
                                                        pp: {
                                                            ...editAreaData.pp,
                                                            suburbId: selectedSub
                                                        }
                                                    })
                                                }}
                                                value={editAreaData?.pp?.suburbId}
                                            />
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </ModalBody>

            <ModalFooter>
                <Button
                    type="submit"
                    onClick={handleUpdateSubmit}
                    style={{ backgroundColor: STYLES.PRIMARY_APP_CLR, color: "white" }}
                >
                    Update
                </Button>
                <Button
                    onClick={() => setIsEditModalOpen(false)}
                    style={{ backgroundColor: STYLES.TERTIARY_APP_CLR, color: "white" }}
                >
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );

    return (
        <>
            <div>
                <CreateAreaDashboardModal />

                {successMessage && (
                    <div style={{ color: "green", marginTop: "10px" }}>
                        {successMessage}
                    </div>
                )}

                {isEditModalOpen ? renderEditModal() : null}
                {isDeleteModalOpen ? renderDeleteModal() : null}
            </div>

            <Row>
                <Card
                    style={{
                        backgroundColor: STYLES.PRIMARY_APP_CLR,
                        width: "100%",
                        height: "20%",
                    }}
                >
                    <CardHeader>
                        <CardTitle tag="h4" style={{ color: "white" }}>
                            Area Table
                        </CardTitle>
                    </CardHeader>
                    <CardBody>
                        <MaterialTable
                            title={"Areas"}
                            columns={[
                                {
                                    title: "Area Name",
                                    field: "areaName",
                                    render: (rowData) => (
                                        <Button
                                            color="white"
                                            onClick={() => {
                                                navigate("/areainfo", { state: rowData });
                                            }} // Pass branch data
                                        >
                                            {rowData.areaName ? rowData.areaName : rowData.Location}
                                        </Button>
                                    )

                                },
                                {
                                    title: "Branch Name",
                                    field: "selectedBranchName"
                                },

                                {
                                    title: "Actions",
                                    render: (rowData) => (
                                        <>
                                            <Button
                                                color="warning"
                                                onClick={() => handleEditClick(rowData)}
                                            >
                                                Edit
                                            </Button>
                                            <Button
                                                color="danger"
                                                onClick={() => handleDeleteClick(rowData)}
                                            >
                                                Delete
                                            </Button>
                                        </>
                                    ),
                                },
                            ]}
                            data={areas}
                            // Use the fetched branches data
                            options={{
                                sorting: true,
                                search: true,
                                paging: true,
                            }}
                        />
                    </CardBody>
                </Card>
                {/* Statistics Card */}

            </Row>
        </>
    );
};

export default areaManagement;
